var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data-name":"RoleCardMenu","data-node-id":"15235:186917"}},[_c(_setup.HorizontalMenu,{attrs:{"items":_setup.menuItems,"size":"small","bottomLine":false,"fixedTabs":false,"value":_setup.selectedTab},on:{"onChange":_setup.handleTabChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }